module.exports = __webpack_public_path__ + "media/images/arrow_down-bcbe1f6a6ccd72dbcbea00300d7eafae.png";